export default "__VITE_ASSET__Dz_l5DwK__"